/**
 * 默认分页的sizeOptions
 */
export const DEFAULT_SIZE_OPTIONS = [20, 30, 50, 100, 200];

/**
 * 默认分页size
 */
export const DEFAULT_SIZE = DEFAULT_SIZE_OPTIONS[2];
